<template>
  <!--  预算编制-->
  <div style="width:100%">
    <van-collapse v-model="activeNames">
      <van-collapse-item title="合同基本信息" name="1">
        <van-field v-model="inputForm.contractCode" label="合同编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractName" label="合同名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.projectName" label="所属项目" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.partyaDeptName" label="合同甲方" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.partyBName" label="合同乙方" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item title="合同执行信息" name="2">
        <van-field v-model="inputForm.contractAmount" label="合同金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalRequestAmount" label="累计已请款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="latestApplicationCaptureAmount" label="含本次申请累计请款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalPaidAmount" label="累计已付款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="paidPercent" label="累计已付款比例(%)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="latestApplicationPaymentAmount" label="含本次申请累计付款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="latestApplicationPaymentPercent" label="含本次申请累计付款金额比例(%)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="restNonPaymentAmount" label="剩余未付款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="restNonPaymentPercent" label="剩余未付款比例(%)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.invoiceAmount" label="已开票金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="invoicePercent" label="已开票金额比例(%)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="restNonInvoiceAmount" label="剩余未开票金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="restNonInvoicePercent" label="剩余未开票金额比例(%)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="paidNonInvoiceAmount" label="已付款未开票金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="paidNonInvoicePercent" label="已付款未开票金额比例(%)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item title="申请付款信息" name="3">
        <van-field v-model="inputForm.code" label="请款单编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.name" label="请款单名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.businessTime" label="申请日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.paymentCompanyName" label="付款单位" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.payeeName" label="收款人名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.payeeBankAccount" label="银行账号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.payeeBank" label="开户银行" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.payeePerson" label="委托收款人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requestAmount" label="本次请款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requestRateAmount" label="本次请款金额比例(%)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.deductionAmount" label="本次扣款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.reversalAmount" label="本次冲账金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.paymentAmount" label="本次实际应付金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="经办人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorDeptName" label="经办部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remarks" label="说明" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field label="事前审批单" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <b-table class="bgc-dark" small head-variant="dark" responsive bordered
                 :items="inputForm.erpBusinessDTOList" :fields="fields">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:cell(businessInfo)="data">
            <div style="color: #4caedc" @click="showDetail(data.item.businessInfo)">{{ data.item.businessInfo }}</div>
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>        <div style="padding-left: 16px;" v-show="inputForm.attachList&&inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="请款明细" name="4">
        <div class="m-form" v-for="(data, index) in inputForm.costRequestDetailDTOList" :key="index">
          <div class="m-row">
            <div class="m-row-text">款项类型</div>
            <div class="m-row-content">{{data.paymentTypeName  }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">应付时间</div>
            <div class="m-row-content">{{ data.planDate }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">计划付款金额(元)</div>
            <div class="m-row-content">{{Number(data.planPaymentAmount).toFixed(2) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">累计请款金额(元)</div>
            <div class="m-row-content">{{Number(data.totalRequestAmount).toFixed(2) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">本次请款金额(元)</div>
            <div class="m-row-content">{{Number(data.requestAmount).toFixed(2) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">付款条件</div>
            <div class="m-row-content large-content">{{data.paymentClause}}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">说明</div>
            <div class="m-row-content large-content">{{ data.remarks }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">核算科目</div>
            <div class="m-row-content large-content">{{ data.accountSubjectFullName||'-' }}</div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="扣款明细" name="9" v-if="inputForm.costRequestContractDeductionDTOList&&inputForm.costRequestContractDeductionDTOList.length>0">
        <div v-for="(data, index) in inputForm.costRequestContractDeductionDTOList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">扣款编号</div>
              <div class="m-row-content">{{ data.deductionCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">扣款单名称</div>
              <div class="m-row-content">{{ data.deductionName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">扣款类型</div>
              <div class="m-row-content">{{ data.deductionTypeName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">扣款金额(元)</div>
              <div class="m-row-content">{{ Number(data.deductionAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">累计已扣款金额(元)</div>
              <div class="m-row-content">{{ Number(data.alreadyDeductionAmount).toFixed(2)  }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">本次扣款金额(元)</div>
              <div class="m-row-content">{{Number(data.thisDeductionAmount).toFixed(2)  }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="预算信息" name="5">
        <div v-for="(data, index) in inputForm.costBudgetDTOList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">预算年度</div>
              <div class="m-row-content large-content">{{ data.budgetAnnual }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算科目编码</div>
              <div class="m-row-content">{{ data.budgetSubjectCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算科目名称</div>
              <div class="m-row-content">{{ data.budgetSubjectName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算金额(元)</div>
              <div class="m-row-content">{{Number(data.budgetAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算已使用金额(元)</div>
              <div class="m-row-content">{{ Number(data.budgetUsedAmount).toFixed(2)  }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算分摊金额(元)</div>
              <div class="m-row-content">{{ Number(data.budgetApportionAmount).toFixed(2)  }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算余额(元)</div>
              <div class="m-row-content">{{Number((data.budgetAmount||0)-(data.budgetUsedAmount||0)-(data.budgetApportionAmount||0)).toFixed(2)   }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="冲账明细" name="6" v-if="inputForm.costRequestReserveRepaymentDTO&&inputForm.costRequestReserveRepaymentDTO.costRequestReserveRepaymentDetailList">
        <div v-for="(data, index) in inputForm.costRequestReserveRepaymentDTO.costRequestReserveRepaymentDetailList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">预付款申请编号</div>
              <div class="m-row-content">{{ data.reserveFundsCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">申请预付款金额(元)</div>
              <div class="m-row-content">{{ Number(data.fundsAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">剩余预付款金额(元)</div>
              <div class="m-row-content">{{ Number(data.noRepaymentAmount).toFixed(2)  }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">本次冲账金额(元)</div>
              <div class="m-row-content">{{Number(data.thisRepaymentAmount).toFixed(2)  }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="发票信息" name="7">
        <div v-for="(data, index) in inputForm.costInvoiceDTOList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">发票号码</div>
              <div class="m-row-content">{{ data.invoiceNum }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">发票类型</div>
              <div class="m-row-content">{{ data.invoiceType }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">发票金额(元)</div>
              <div class="m-row-content">{{Number(data.amount).toFixed(2) }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="劳务费用完工结算清单" name="8" v-if="inputForm.costRequestCompletionSettlementDTOList.length > 0">
        <div v-for="(data, index) in inputForm.costRequestCompletionSettlementDTOList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">立项/报修事项</div>
              <div class="m-row-content large-content">{{ data.itemName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">立项/报修编号</div>
              <div class="m-row-content large-content">{{ data.itemCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">立项/报修日期</div>
              <div class="m-row-content">{{ data.itemDate }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">结账日期</div>
              <div class="m-row-content">{{ data.checkoutDate }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">结算单编号</div>
              <div class="m-row-content large-content">{{ data.settlementCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">劳务结算费用(元)</div>
              <div class="m-row-content">{{ Number(data.settlementAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">已付款金额(元)</div>
              <div class="m-row-content">{{ Number(data.paidAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">剩余未付款金额(元)</div>
              <div class="m-row-content">{{ Number(data.unPaidAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">本次请款金额(元)</div>
              <div class="m-row-content">{{ Number(data.requestAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">余款(元)</div>
              <div class="m-row-content">{{ Number(data.leftAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">备注</div>
              <div class="m-row-content large-content">{{ data.contractRemarks }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>

    </van-collapse>
  </div>
</template>

<script>
import QueryInfoService from '@/api/system/queryInfoService'
import Decimal from "decimal.js";

export default {
  name: "contractRequestFunds",
  data(){
    return {
      activeNames: [ '3', '4', '5', '6', '7'],
      inputForm:{
        id:'',
        contractCode:'',
        contractName:'',
        projectName:'',
        partyaDeptId:'',
        partyBName:'',
        contractAmount:'',
        totalRequestAmount:'',
        totalPaidAmount:'',
        invoiceAmount:'',
        name:'',
        businessTime:'',
        paymentCompanyId:'',
        payeeBankAccount:'',
        payeeBank:'',
        payeePerson:'',
        requestAmount:'',
        requestRateAmount:'',
        deductionAmount:'',
        reversalAmount:'',
        paymentAmount:'',
        operatorName:'',
        operatorDeptName:'',
        createByName:'',
        createDate:'',
        remarks:'',
        attachList:[],
        costRequestDetailDTOList:[],
        costRequestContractDeductionDTOList: [],
        costBudgetDTOList:[],
        costRequestReserveRepaymentDTO: {
          costRequestReserveRepaymentDetailList: [],
          documentId: ''
        },
        costInvoiceDTOList:[],
        costRequestCompletionSettlementDTOList: [],
        erpBusinessDTOList:[],
      },
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'businessInfo', label: '业务信息', minWidth: '120px'},
      ],
      paidPercent:null,
      restNonPaymentAmount:null,
      restNonPaymentPercent:null,
      latestApplicationPaymentAmount:null,
      latestApplicationPaymentPercent:null,
      latestApplicationCaptureAmount:null,
      invoicePercent:null,
      restNonInvoiceAmount:null,
      restNonInvoicePercent:null,
      paidNonInvoiceAmount:null,
      paidNonInvoicePercent:null,
    }
  },
  created() {
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    init(data) {
      this.$nextTick(()=>{
        this.inputForm = data
        if(this.inputForm.costRequestCompletionSettlementDTOList && this.inputForm.costRequestCompletionSettlementDTOList.length > 0) {
          this.inputForm.costRequestCompletionSettlementDTOList.forEach(item => {
            item.unPaidAmount = new Decimal(item.settlementAmount).sub(new Decimal(item.paidAmount)).toFixed(2, Decimal.ROUND_HALF_UP)
            item.leftAmount = new Decimal(item.settlementAmount).sub(new Decimal(item.paidAmount)).sub(new Decimal(item.requestAmount)).toFixed(2, Decimal.ROUND_HALF_UP)
          })
        }
        this.inputForm.createDate =  this.inputForm.createDate.slice(0,10)
        this.updateDictNames(this.inputForm.costRequestDetailDTOList,{cost_contract_payment_type:'paymentType'})
        this.inputForm.createByName=data.createBy.name
        this.calcAmount()
        const amounts = [
          [this.inputForm.contractAmount, 'contractAmount'],
          [this.inputForm.totalRequestAmount, 'totalRequestAmount'],
          [this.inputForm.totalPaidAmount, 'totalPaidAmount'],
          [this.inputForm.invoiceAmount, 'invoiceAmount'],
          [this.inputForm.requestAmount, 'requestAmount'],
          [this.inputForm.requestRateAmount, 'requestRateAmount'],
          [this.inputForm.reversalAmount, 'reversalAmount'],
          [this.inputForm.paymentAmount, 'paymentAmount'],
          [this.inputForm.deductionAmount, 'deductionAmount'],
        ].map(([value, formField]) => {
          this.$set(this.inputForm, `${formField}`, Number(value).toFixed(2));
        });
        this.inputForm.requestRateAmount = this.getPercent(this.inputForm.requestAmount, this.inputForm.contractAmount)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Name`, dictItem.label);
            }
          }
        }
      });
    },
    // 计算合同执行信息
    calcAmount(){
      this.paidPercent=this.getPercent(this.inputForm.totalPaidAmount,this.inputForm.contractAmount)
      this.restNonPaymentAmount=new Decimal(this.inputForm.contractAmount || 0).minus(new Decimal(this.inputForm.totalPaidAmount || 0)).toFixed(2, Decimal.ROUND_HALF_UP)
      this.restNonPaymentPercent=this.getPercent(this.restNonPaymentAmount,this.inputForm.contractAmount)
      this.latestApplicationPaymentAmount=new Decimal(this.inputForm.totalPaidAmount || 0).add(new Decimal(this.inputForm.requestAmount || 0)).toFixed(2, Decimal.ROUND_HALF_UP)
      this.latestApplicationPaymentPercent=this.getPercent(this.latestApplicationPaymentAmount,this.inputForm.contractAmount)
      this.latestApplicationCaptureAmount=new Decimal(this.inputForm.totalRequestAmount || 0).add(new Decimal(this.inputForm.requestAmount || 0)).toFixed(2, Decimal.ROUND_HALF_UP)
      this.invoicePercent=this.getPercent(this.inputForm.invoiceAmount,this.inputForm.contractAmount)
      this.restNonInvoiceAmount=new Decimal(this.inputForm.contractAmount || 0).minus(new Decimal(this.inputForm.invoiceAmount || 0)).toFixed(2, Decimal.ROUND_HALF_UP)
      this.restNonInvoicePercent=this.getPercent(this.restNonInvoiceAmount,this.inputForm.contractAmount)
      this.paidNonInvoiceAmount=new Decimal(this.inputForm.totalPaidAmount || 0).minus(new Decimal(this.inputForm.invoiceAmount || 0)).toFixed(2, Decimal.ROUND_HALF_UP)
      this.paidNonInvoicePercent=this.getPercent(this.paidNonInvoiceAmount,this.inputForm.totalPaidAmount)
    },
    // 计算比例
    getPercent(num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0 ? "0" : (Math.round(num / total * 10000) / 100.00);
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
